module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.06.d-159c431721e68384ea24a6df8154ef82.svg";